// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer_footer-panel__T0wZZ {
  background: #222222;
  padding: 56px 0;
  margin-top: 16px;
}

.footer_footer-panel__T0wZZ a {
  text-decoration: none;
}

.footer_accordion_footer__28hOR {
  color: #8c8c8c;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 600;
  line-height: 15.6px;
  letter-spacing: normal;
  text-align: left;
  border-top: none;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.footer_panel__2FLkv li a {
  font-family: "Inter", sans-serif;
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0em;
  text-align: left;
  text-decoration: none;
}

.footer_panel__2FLkv {
  padding: 0;
  max-height: auto;
  overflow: hidden;
  transition: max-height 0.2s ease-out;
}

.footer_list-unstyled__QEVDm {
  margin-bottom: 0px;
}

.footer_panel__2FLkv li {
  margin-top: 16px;
  height: 100%;
}

.footer_footer-panel__T0wZZ hr {
  background-color: #666666;
  margin: 24px 0;
  border-color: #666666 !important;
  opacity: 1;
}

.footer_terms-condition__GPMRG {
  padding-bottom: 30px;
  padding-top: 40px;
}

.footer_terms-condition__GPMRG ol li,
.footer_terms-condition__GPMRG p {
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  padding-top: 20px;
}

.footer_terms-condition__GPMRG ol {
  padding-left: 15px;
}

.footer_terms-condition__GPMRG ol li span {
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  display: block;
  padding-top: 20px;
}

a.footer_greentext__DqzcV {
  color: #1ee576;
  text-decoration: underline;
}

.footer_social-panel__k5J30 {
  width: 100%;
  padding: 0;
}

.footer_social-panel__k5J30 a {
  padding-right: 14px;
}

.footer_social-panel__k5J30 .footer_col-md-6__K\\+tUy {
  padding-left: 0;
}

.footer_brand-icon__QBcKi a {
  padding-right: 40px;
}

.footer_brand-icon__QBcKi {
  display: flex;
  justify-content: right;
}

.footer_brand-icon__QBcKi a:last-child {
  padding-right: 0;
}

.footer_last-section__U7qev ul li:last-child {
  padding-right: 0;
}

@media screen and (max-width: 600px) {
  .footer_footer-panel__T0wZZ {
    padding: 16px 0 24px;
  }
  .footer_footer-panel__T0wZZ .footer_nav-list__FpzEw {
    width: 100% !important;
  }
  .footer_last-section__U7qev .footer_f-row__6Ckxq {
    flex-direction: column-reverse;
  }
  .footer_social-panel__k5J30 {
    padding: 0;
  }
  .footer_social-panel__k5J30 .footer_col-md-6__K\\+tUy {
    padding-left: 16px;
  }
  h5.footer_accordion_footer__28hOR {
    padding: 16px 0;
    margin-top: 0px;
    margin-bottom: 0;
  }
  .footer_mob-border__l5lXQ {
    border-bottom: 1px solid #666;
  }
  .footer_footer-panel__T0wZZ .footer_panel__2FLkv {
    padding: 0;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.2s ease-out;
  }
  .footer_brand-icon__QBcKi {
    display: block;
    padding-top: 24px;
    display: flex;
    column-gap: 32px;
    row-gap: 24px;
    flex-flow: wrap;
    justify-content: flex-start;
  }
  .footer_brand-icon__QBcKi a {
    padding-right: 30px !important;
  }
  .footer_brand-icon__QBcKi a img {
    margin-bottom: 0 !important;
  }
  .footer_terms-condition__GPMRG {
    padding: 32px 32px 16px 32px !important;
  }
  .footer_terms-condition__GPMRG p:first-child {
    padding-top: 0;
  }
  .footer_brand-icon__QBcKi a img {
    margin-bottom: 24px;
  }
  .footer_last-section__U7qev p {
    margin-bottom: 12px;
  }
  .footer_last-section__U7qev p img {
    display: block;
    margin-left: 0;
    margin-bottom: 16px;
  }
  .footer_last-section__U7qev ul li {
    display: block !important;
    padding: 0 !important;
    margin-bottom: 8px;
  }
  .footer_last-section__U7qev ul li:last-child img {
    margin-left: 4px;
    height: 24px;
  }
}
.footer_last-section__U7qev p {
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
}

.footer_last-section__U7qev img {
  padding-right: 0px;
  margin-left: 0px;
}

.footer_last-section__U7qev ul {
  padding-left: 0;
  text-align: end;
}

.footer_last-section__U7qev ul li {
  list-style: none;
  display: inline-block;
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  padding: 0 16px;
}
.footer_last-section__U7qev ul li:last-child img {
  margin-left: 4px;
  height: 24px;
}

.footer_last-section__U7qev ul li a {
  color: #ffffff;
}

.footer_last-section__U7qev .footer_col-md-6__K\\+tUy {
  padding: 0;
}

.footer_brand-icon__QBcKi {
  text-align: right;
  padding-right: 0 !important;
}

.footer_brand-icon__QBcKi a {
  padding-right: 20px;
}

.footer_privacy-choice__ibeB2 {
  margin-left: 5px;
}

.footer_footer-panel__T0wZZ .footer_nav-list__FpzEw {
  width: 20%;
}`, "",{"version":3,"sources":["webpack://./src/styles/footer.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,cAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,gCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AACF;;AAEA;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,gBAAA;EACA,YAAA;AACF;;AAEA;EACE,yBAAA;EACA,cAAA;EACA,gCAAA;EACA,UAAA;AACF;;AAEA;EACE,oBAAA;EACA,iBAAA;AACF;;AAEA;;EAEE,cAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,cAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AACF;;AAEA;EACE,cAAA;EACA,0BAAA;AACF;;AAEA;EACE,WAAA;EACA,UAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE;IACE,oBAAA;EACF;EACA;IACE,sBAAA;EACF;EACA;IACE,8BAAA;EACF;EACA;IACE,UAAA;EACF;EAAE;IACI,kBAAA;EAEN;EAEA;IACE,eAAA;IACA,eAAA;IACA,gBAAA;EAAF;EAGA;IACE,6BAAA;EADF;EAIA;IACE,UAAA;IACA,aAAA;IACA,gBAAA;IACA,oCAAA;EAFF;EAKA;IACE,cAAA;IACA,iBAAA;IACA,aAAA;IAEA,gBAAA;IACA,aAAA;IACA,eAAA;IACA,2BAAA;EAHF;EAIE;IACE,8BAAA;EAFJ;EAGI;IACE,2BAAA;EADN;EAMA;IAEI,uCAAA;EALJ;EAOU;IACI,cAAA;EALd;EAUA;IACE,mBAAA;EARF;EAWM;IACI,mBAAA;EATV;EAUU;IACI,cAAA;IACA,cAAA;IACA,mBAAA;EARd;EAYA;IACE,yBAAA;IACE,qBAAA;IACE,kBAAA;EAVN;EAYU;IACI,gBAAA;IACA,YAAA;EAVd;AACF;AAeA;EACE,cAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,gBAAA;AAbF;;AAgBA;EACE,eAAA;EACA,eAAA;AAbF;;AAgBA;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AAbF;AAeQ;EACI,gBAAA;EACA,YAAA;AAbZ;;AAkBA;EACE,cAAA;AAfF;;AAkBA;EACE,UAAA;AAfF;;AAiBA;EACE,iBAAA;EACA,2BAAA;AAdF;;AAgBA;EACE,mBAAA;AAbF;;AAeA;EACE,gBAAA;AAZF;;AAeA;EACE,UAAA;AAZF","sourcesContent":[".footer-panel {\n  background: #222222;\n  padding: 56px 0;\n  margin-top: 16px;\n}\n\n.footer-panel a {\n  text-decoration: none;\n}\n\n.accordion_footer {\n  color: #8c8c8c;\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 15.6px;\n  letter-spacing: normal;\n  text-align: left;\n  border-top: none;\n  text-transform: uppercase;\n  margin-bottom: 8px;\n}\n\n.panel li a {\n  font-family: \"Inter\", sans-serif;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 28px;\n  letter-spacing: 0em;\n  text-align: left;\n  text-decoration: none;\n}\n\n.panel {\n  padding: 0;\n  max-height: auto;\n  overflow: hidden;\n  transition: max-height 0.2s ease-out;\n}\n\n.list-unstyled {\n  margin-bottom: 0px;\n}\n\n.panel li {\n  margin-top: 16px;\n  height: 100%;\n}\n\n.footer-panel hr {\n  background-color: #666666;\n  margin: 24px 0;\n  border-color: #666666 !important;\n  opacity: 1;\n}\n\n.terms-condition {\n  padding-bottom: 30px;\n  padding-top: 40px;\n}\n\n.terms-condition ol li,\n.terms-condition p {\n  color: #ffffff;\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  text-align: left;\n  padding-top: 20px;\n}\n\n.terms-condition ol {\n  padding-left: 15px;\n}\n\n.terms-condition ol li span {\n  color: #ffffff;\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  text-align: left;\n  display: block;\n  padding-top: 20px;\n}\n\na.greentext {\n  color: #1ee576;\n  text-decoration: underline;\n}\n\n.social-panel {\n  width: 100%;\n  padding: 0;\n}\n\n.social-panel a {\n  padding-right: 14px;\n}\n\n.social-panel .col-md-6 {\n  padding-left: 0;\n}\n\n.brand-icon a {\n  padding-right: 40px;\n}\n\n.brand-icon {\n  display: flex;\n  justify-content: right;\n}\n\n.brand-icon a:last-child {\n  padding-right: 0;\n}\n\n.last-section ul li:last-child {\n  padding-right: 0;\n}\n\n@media screen and (max-width: 600px) {\n  .footer-panel {\n    padding: 16px 0 24px;\n  }\n  .footer-panel .nav-list {\n    width: 100% !important;\n  }\n  .last-section .f-row {\n    flex-direction: column-reverse;\n  }\n  .social-panel {\n    padding: 0;\n    .col-md-6{\n        padding-left: 16px;\n    }\n  }\n\n  h5.accordion_footer {\n    padding: 16px 0;\n    margin-top: 0px;\n    margin-bottom: 0;\n  }\n\n  .mob-border {\n    border-bottom: 1px solid #666;\n  }\n\n  .footer-panel .panel {\n    padding: 0;\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.2s ease-out;\n  }\n\n  .brand-icon {\n    display: block;\n    padding-top: 24px;\n    display: flex;\n    -moz-column-gap: 32px;\n    column-gap: 32px;\n    row-gap: 24px;\n    flex-flow: wrap;\n    justify-content: flex-start;\n    a {\n      padding-right: 30px !important;\n      img {\n        margin-bottom: 0 !important;\n      }\n    }\n  }\n\n  .terms-condition {\n  \n      padding: 32px 32px 16px 32px !important;\n        p{\n            &:first-child{\n                padding-top: 0;\n            }\n        }\n  }\n\n  .brand-icon a img {\n    margin-bottom: 24px;\n  }\n  .last-section{\n        p{\n            margin-bottom: 12px;\n            img{\n                display: block;\n                margin-left: 0;\n                margin-bottom: 16px;\n            }\n        }\n    }\n  .last-section ul li {\n    display: block !important;\n      padding: 0 !important;\n        margin-bottom: 8px;\n        &:last-child{\n            img{\n                margin-left: 4px;\n                height: 24px;\n            }\n        }\n  }\n}\n\n.last-section p {\n  color: #ffffff;\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  text-align: left;\n}\n\n.last-section img {\n  padding-right: 0px;\n  margin-left: 0px;\n}\n\n.last-section ul {\n  padding-left: 0;\n  text-align: end;\n}\n\n.last-section ul li {\n  list-style: none;\n  display: inline-block;\n  color: #ffffff;\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  text-align: left;\n  padding: 0 16px;\n    &:last-child{\n        img{\n            margin-left: 4px;\n            height: 24px;\n        }\n    }  \n}\n\n.last-section ul li a {\n  color: #ffffff;\n}\n\n.last-section .col-md-6 {\n  padding: 0;\n}\n.brand-icon {\n  text-align: right;\n  padding-right: 0 !important;\n}\n.brand-icon a {\n  padding-right: 20px;\n}\n.privacy-choice {\n  margin-left: 5px;\n}\n\n.footer-panel .nav-list {\n  width: 20%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer-panel": `footer_footer-panel__T0wZZ`,
	"accordion_footer": `footer_accordion_footer__28hOR`,
	"panel": `footer_panel__2FLkv`,
	"list-unstyled": `footer_list-unstyled__QEVDm`,
	"terms-condition": `footer_terms-condition__GPMRG`,
	"greentext": `footer_greentext__DqzcV`,
	"social-panel": `footer_social-panel__k5J30`,
	"col-md-6": `footer_col-md-6__K+tUy`,
	"brand-icon": `footer_brand-icon__QBcKi`,
	"last-section": `footer_last-section__U7qev`,
	"nav-list": `footer_nav-list__FpzEw`,
	"f-row": `footer_f-row__6Ckxq`,
	"mob-border": `footer_mob-border__l5lXQ`,
	"privacy-choice": `footer_privacy-choice__ibeB2`
};
export default ___CSS_LOADER_EXPORT___;
